import {CSSProperties } from "react";
import BeatLoader from "react-spinners/BeatLoader";
const override: CSSProperties = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
};

const backdropStyle: CSSProperties = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent backdrop
    zIndex: 9999, // Ensure it appears on top
};

const Loader = () => {
    return (
        <div style={backdropStyle}>
            <BeatLoader
                color="#212529"
                loading={true}
                cssOverride={override}
                size={10}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
    )
}
export default Loader